if (window.location.pathname.includes('/collections/')) {

  document.addEventListener('click', function (e) {
    const productLink = e.target.closest('a[href*="/products/"]');
    if (!productLink) return;

    sessionStorage.setItem('collectionScrollPosition', window.scrollY);
  });

  function restoreScroll() {
    const savedScroll = sessionStorage.getItem('collectionScrollPosition');

    if (savedScroll) {
        if ('scrollRestoration' in history) {
            history.scrollRestoration = 'manual';
        }
        setTimeout(() => {
        window.scrollTo(0, parseInt(savedScroll));
        
        // Clean up the storage so it doesn't trigger again unexpectedly
        sessionStorage.removeItem('collectionScrollPosition');
        }, 50);
    }
    }

  window.restoreScroll = restoreScroll;

  function observeProductGrid() {
    const selector = '#js-product-ajax';
    const targetNode = document.querySelector(selector);
    if (!targetNode) {
      console.error(`Observer Error: Selector "${selector}" not found.`);
      return;
    }

    // 1. Initialize the count outside the observer
    let currentItemCount = targetNode.querySelector('.row').children.length;

    // 2. Define the observer logic
    const observer = new MutationObserver((mutationsList) => {
      for (const mutation of mutationsList) {
        if (mutation.type === 'childList') {
          const newNodeCount = targetNode.querySelector('.row').children.length;

          // 3. Check if the number has increased
          if (newNodeCount > currentItemCount) {
            setTimeout(() => window.restoreScroll(), 500);

            // 4. Stop observing immediately
            observer.disconnect();
            return; // Exit the loop and callback
          }

          // Update the reference count if it decreased or stayed same
          currentItemCount = newNodeCount;
        }
      }
    });

    // 5. Start observing
    observer.observe(targetNode, {
      childList: true,
      subtree: true
    });

  }

  window.observeProductGrid = observeProductGrid;


}